import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IRoleAndPermission } from "../../services/user-role-administration-service/Models";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseRolePermissionsReportParameters = {
    organizationID: number;
    groupID: number;
} & BaseUseQueryParameters<IRoleAndPermission[]>;

export function useRolePermissionsReport({
    organizationID,
    groupID,
    enabled,
    onError,
    onSuccess
}: UseRolePermissionsReportParameters) {
    return useQuery<IRoleAndPermission[], RestError, IRoleAndPermission[]>(
        keys.userPermissionsReport(organizationID, groupID),
        ({ signal }) => {
            return UserRoleAdministrationService.getRolePermissionsReport(organizationID, groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: 0
        }
    );
}
